<!--
  ~ Copyright (C) 2018 Robert Bosch GmbH Copyright (C) 2018 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
  -->

<a *ngIf="url !== undefined" (click)="navigateToUrl()">{{
  omitted ? "…" : title
}}</a>
<ng-container *ngIf="url === undefined">{{
  omitted ? "…" : title
}}</ng-container>
